import React from "react"
import CharadesIcon from "../assets/charadesIcon"
import CoffeeIcon from "../assets/coffeeIcon"
import DoodleColorIcon from "../assets/doodleIcon"
import IceBreakerIcon from "../assets/iceBreakerIcon"
import KnowYourTeamIcon from "../assets/kytIcon"
import LoungeSVG from "../assets/loungeSVG"
import MindfulTalksIcon from "../assets/MindfulTalksIcon"
import Speed1on1Icon from "../assets/speed1-1Icon"
import TemplatesCoffeeIcon from "../assets/templatesCoffeeIcon"
import TriviaColorIcon from "../assets/triviaIcon"
import TtalIcon from "../assets/ttalIcon"
import WYRColorIcon from "../assets/wyrIcon"
import { AmplitudeEvents } from "../types/amplitudeEvents"
import {
  handleMouseDownEvent,
  handleMouseUpEvent,
} from "../utils/buttonClickScaleEffect"
import { ActivityEnum } from "../utils/constants"

// import InstantSocial from "../common/InstantSocial"
import "./WhatsInsideModal.css"

interface WhatsInsideModalProps {
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  templateDetail?: any | undefined
  startTemplateHandler: (templateCode: string, amplitudeEvent: string) => void
  templateNumber: number
}

const getActivityIcon = (activityName: string) => {
  let icon
  switch (activityName) {
    case ActivityEnum.WOULD_YOU_RATHER:
      icon = <WYRColorIcon />
      break
    case ActivityEnum.TRIVIA:
      icon = <TriviaColorIcon />
      break
    case ActivityEnum.DOODLE_RACE:
      icon = <DoodleColorIcon />
      break
    case ActivityEnum.TWO_TRUTHS_AND_A_LIE:
      icon = <TtalIcon />
      break
    case ActivityEnum.CHARADES:
      icon = <CharadesIcon />
      break
    case ActivityEnum.LOUNGE:
      icon = <WYRColorIcon />
      break
    case ActivityEnum.SPEED_1_1:
      icon = <Speed1on1Icon />
      break
    case ActivityEnum.ICEBREAKER:
      icon = <IceBreakerIcon />
      break
    case ActivityEnum.KNOW_YOUR_TEAM:
      icon = <KnowYourTeamIcon />
      break
    case ActivityEnum.MINDFUL_TALKS:
      icon = <MindfulTalksIcon />
      break
    case ActivityEnum.MINDFUL_TALKS_APPRECIATION:
      icon = <MindfulTalksIcon />
      break
    case ActivityEnum.SHARE_OUT_IN_LOUNGE:
      icon = <LoungeSVG />
      break

    default:
  }

  return icon
}

const getActivityBgColor = (activityName: string) => {
  let color
  switch (activityName) {
    case ActivityEnum.WOULD_YOU_RATHER:
      color = "#e9f7f3"
      break
    case ActivityEnum.TRIVIA:
      color = "#FDF2EA"
      break
    case ActivityEnum.DOODLE_RACE:
      color = "#fff9e6"
      break
    case ActivityEnum.TWO_TRUTHS_AND_A_LIE:
      color = "#e9f7f3"
      break
    case ActivityEnum.CHARADES:
      color = "#E6F7FF"
      break
    case ActivityEnum.LOUNGE:
      color = "#E6F7FF"
      break
    case ActivityEnum.SPEED_1_1:
      color = "#e6f7ff"
      break
    case ActivityEnum.ICEBREAKER:
      color = "#f0ebff"
      break
    case ActivityEnum.KNOW_YOUR_TEAM:
      color = "#fdf2ea"
      break
    case ActivityEnum.SHARE_OUT_IN_LOUNGE:
      color = "#f0ebff"
      break
    case ActivityEnum.MINDFUL_TALKS:
      color = "#e9f7f3"
      break
    case ActivityEnum.MINDFUL_TALKS_APPRECIATION:
      color = "#e9f7f3"
      break
    default:
  }

  return color
}

const getAmplitudeEvent = (templateNumber: number) => {
  return AmplitudeEvents[
    `CREATE_SOCIAL_FROM_TEMPLATES_CARD${templateNumber + 1}`
  ]
}

const WhatsInsideModal: React.FC<WhatsInsideModalProps> = ({
  show = true,
  setShow,
  templateDetail,
  startTemplateHandler,
  templateNumber,
}) => {
  return (
    <>
      {show && (
        <>
          <div className="MainContainer" onClick={() => setShow(false)}></div>
          <div className="Modal">
            <div className="WhatIsInsideContainer">
              <div className="WIHeader">
                <div className="WIHeaderLeft">
                  <div className="TemplateIconContainer">
                    {templateDetail?.template?.logo}
                  </div>

                  <div className="body-txt black-txtBtn">
                    <b>{templateDetail?.template?.name}</b>
                  </div>
                </div>
                <div className="WIHeaderRight">
                  {/* <div className="TagsContainer">
                    <div className="Tags">Fun</div>
                    <div className="Tags green-tag">Casual</div>
                  </div> */}
                  <div className="time-container">
                    <div className="time-duration">
                      {templateDetail?.template?.approximateTime}
                    </div>
                    <div className="minutes-text">minutes</div>
                  </div>
                </div>
              </div>
              <div className="WIDescription">
                {templateDetail?.template?.description}
              </div>

              <div className="WhatsInsideModalText"> What's inside:</div>
              {templateDetail?.templateItems?.map((ti, index) => {
                return (
                  <div
                    className="ActivitySection"
                    style={
                      index + 1 !== templateDetail.templateItems.length
                        ? {
                            borderColor: getActivityBgColor(ti.activityName),
                          }
                        : null
                    }
                  >
                    <div
                      className="ActivityIcon"
                      style={{
                        background: getActivityBgColor(ti.activityName),
                      }}
                    >
                      {getActivityIcon(ti.activityName)}
                    </div>
                    <div className="ActivityName">{ti.activityName}</div>
                    <div className="ActivityDescription">
                      {ti.activityDescription}
                    </div>
                  </div>
                )
              })}
            </div>

            <div
              style={{
                position: "relative",
                bottom: "0px",
                display: "flex",
                margin: "16px 0 0px 0",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() =>
                  startTemplateHandler(
                    templateDetail?.template?.templateCode,
                    getAmplitudeEvent(templateNumber)
                  )
                }
                onMouseDown={handleMouseDownEvent}
                onMouseUp={handleMouseUpEvent}
                className="modal-price-btn purpleBtn white-color"
              >
                {templateDetail?.template?.btnText}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default WhatsInsideModal
